<template>
  <header class="header">
    <div class="container">
      <nav class="navbar">
        <div class="navbar-brand">
          <router-link to="/" class="brand-link">
            <h1>掌柜助手</h1>
          </router-link>
        </div>
        <div class="navbar-menu" :class="{ 'is-active': isMenuOpen }">
          <router-link to="/" class="nav-link" @click.native="closeMenu" exact>首页</router-link>
          <router-link to="/introduce" class="nav-link" @click.native="closeMenu">产品介绍</router-link>
          <router-link to="/download" class="nav-link" @click.native="closeMenu">产品下载</router-link>
          <router-link to="/webpush" class="nav-link" @click.native="closeMenu">离线通知</router-link>
          <router-link to="/agent" class="nav-link" @click.native="closeMenu">代理加盟</router-link>
          <a href="#contact" class="nav-link contact-btn" @click="closeMenu">联系客服</a>
        </div>
        <div class="navbar-burger" @click="toggleMenu">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      isMenuOpen: false
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    closeMenu() {
      this.isMenuOpen = false
    }
  }
}
</script>

<style scoped>
.header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
}

.navbar-brand .brand-link {
  text-decoration: none;
  color: white;
}

.navbar-brand h1 {
  font-size: 28px;
  font-weight: bold;
  margin: 0;
  background: linear-gradient(45deg, #fff, #f0f8ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.navbar-menu {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.nav-link {
  color: white;
  text-decoration: none;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 20px;
  transition: all 0.3s ease;
  position: relative;
}

.nav-link:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

.nav-link.router-link-active {
  background: rgba(255, 255, 255, 0.2);
  font-weight: bold;
}

.contact-btn {
  background: linear-gradient(45deg, #ff6b6b, #ee5a24);
  color: white !important;
  font-weight: bold;
}

.contact-btn:hover {
  background: linear-gradient(45deg, #ee5a24, #d63031);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(238, 90, 36, 0.3);
}

.navbar-burger {
  display: none;
  flex-direction: column;
  cursor: pointer;
  padding: 5px;
}

.navbar-burger span {
  width: 25px;
  height: 3px;
  background: white;
  margin: 3px 0;
  transition: 0.3s;
  border-radius: 2px;
}

@media (max-width: 768px) {
  .navbar-menu {
    position: fixed;
    top: 70px;
    left: 0;
    right: 0;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    flex-direction: column;
    padding: 2rem 0;
    transform: translateY(-100%);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
  }

  .navbar-menu.is-active {
    transform: translateY(0);
    opacity: 1;
    visibility: visible;
  }

  .navbar-burger {
    display: flex;
  }

  .nav-link {
    padding: 12px 20px;
    width: 100%;
    text-align: center;
  }
}
</style>
